import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginData = {username: '', password: ''};
  retUrl: string = '';
  retUrlParam: any;
  hide = true;
  constructor(private authenticationService: AuthenticationService,
    private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    console.log('iniciando ngOnInit');
    this.activatedRoute.queryParamMap
      .subscribe(params => {
        this.retUrl = params.get('retUrl');
        if (params.get('elemento_id')){
          this.retUrlParam = { elemento_id: params.get('elemento_id'), elemento_nombre: params.get('elemento_nombre'),
          x: params.get('x'), y: params.get('y'), lat: params.get('lat'), long: params.get('long'),
          classId: params.get('class_id'), className: params.get('class_name')
        };
        } else if (params.get('x')){
          this.retUrlParam = { x: params.get('x'), y: params.get('y'), lat: params.get('lat'), long: params.get('long') };
        } else if (params.get('id')) {
          this.retUrlParam = { id: params.get('id'), accion: params.get('accion')};
        }  else {
          this.retUrlParam = {};
        }
        console.log( 'LoginComponent/ngOnInit ' + this.retUrl);
      });
  }
  get passwordInput() { return this.loginData.password; }
  login() {
    console.log('realizando el login username ' + this.loginData.username);
    this.authenticationService.loginWithCredentials(this.loginData.username, this.loginData.password)
    .then(() => {
      console.log('successfully logged in');
      console.log( 'return to ' + this.retUrl);

      this.activatedRoute.queryParamMap
      .subscribe(params => {
        console.log('dentro de queryparam');
        if (params.get('elemento_id')){
          console.log('tiene elemento id ' + params.get('elemento_id'));
          this.retUrlParam = { elemento_id: params.get('elemento_id'), elemento_nombre: params.get('elemento_nombre'),
          x: params.get('x'), y: params.get('y'), lat: params.get('lat'), long: params.get('long'),
          classId: params.get('class_id'), className: params.get('class_name')};
        } else if (params.get('x')) {
          console.log('tiene x ' + params.get('x'));
          this.retUrlParam = { x: params.get('x'), y: params.get('y') , lat: params.get('lat'), long: params.get('long') };
        } else if (params.get('id')) {
          this.retUrlParam = { id: params.get('id'), accion: params.get('accion')};
        }  else {
          console.log('no tiene parametros');
          this.retUrlParam = {};
        }
      });
      this.authenticationService.loadUserDetails().then(() => {
        console.error('sucessfully loadUserProfile');
        if ( this.retUrl != null) {
          this.router.navigate( [this.retUrl], { queryParams: this.retUrlParam});
        } else {
          this.router.navigate( ['home'] , { queryParams: this.retUrlParam});
        }
      })
      .catch(err => {
        console.error('error loadUserProfile');
      });
    })
    .catch(err => {
      console.error('error logging in');

    });


}
}
